import React from 'react';

/** Hangar icon — asset fourni par l'utilisateur (masque + currentColor). */
export default function PersonalHubHangarIcon({ className = '' }) {
  return (
    <span
      className={['personal-hub-rail__hangar-icon', className].filter(Boolean).join(' ')}
      aria-hidden="true"
    />
  );
}
